module.exports = __webpack_public_path__ + "static/img/6introduce（bak）.cccbbf23.jpg";